module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-select"
  }, [_c('div', {
    staticClass: "_body"
  }, [_c('div', {
    staticClass: "_header"
  }, [_vm._v("\n            " + _vm._s(_vm.item.title) + "\n        ")]), _vm._v(" "), _c('div', {
    class: ("option-list " + (_vm.item.option_list.length > 2 ? 'type-2' : 'type-1'))
  }, _vm._l((_vm.item.option_list), function(option) {
    return _c('div', {
      staticClass: "option-item"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(option.option))]), _vm._v(" " + _vm._s(option.desc))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "_bottom"
  }, [_c('div', {
    staticClass: "button-list"
  }, _vm._l((_vm.item.option_list), function(option) {
    return _c('div', {
      staticClass: "button-item",
      class: {
        active: _vm.isSelected(option.id)
      },
      on: {
        "click": function($event) {
          _vm.buttonClick(option)
        }
      }
    }, [_vm._v(_vm._s(option.option))])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1090608d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuestionTypeSelect.vue
// module id = 269
// module chunks = 1